exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pickup-address-info-text h4{color:#ba1913;font-size:18px}.pickup-address-info-text p{font-size:14px}", ""]);

// exports
